import { optionsToStrategy } from "@/common/utils/optionsToStrategy"

export const options = [
  { label: 'Operacional', value: 'operational' },
  { label: 'Administrativo', value: 'administrative' },
  { label: 'Comercial', value: 'commercial' },
]

export const strategy = optionsToStrategy(options)
